import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { MarketProductVendor, VendorDisplay } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type VendorResponse = MarketProductVendor;
type VendorDisplayResponse = VendorDisplay;

export interface VendorDataSource {
  getVendor(vendorId: number): Promise<VendorResponse>;
  getVendorDisplay(vendorId: number): Promise<VendorDisplayResponse>;
}

export class VendorDataSourceImpl implements VendorDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getVendor(vendorId: number) {
    return this.client.request<VendorResponse>({
      url: `/api/market-place/v1/vendors/${vendorId}`,
      method: 'get',
    });
  }

  async getVendorDisplay(vendorId: number) {
    return this.client.request<VendorDisplayResponse>({
      url: `/api/market-place/v1/vendor/${vendorId}/display`,
      method: 'get',
    });
  }
}

export const vendorDataSource = new VendorDataSourceImpl();
